var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "carteira-ativos az-card-bordered",
      class: { "carteira-ativos--loading": _vm.showLoadingState }
    },
    [
      _c(
        "FeedbackWrapper",
        {
          attrs: {
            loading: _vm.showLoadingState,
            message: _vm.WALLET_EMPTY_MESSAGE,
            minHeight: 425
          }
        },
        [
          _c("div", { staticClass: "carteira-ativos__header" }, [
            _c(
              "div",
              { staticClass: "carteira-ativos__title" },
              [
                _c(
                  "span",
                  {
                    staticClass: "carteira-ativos__title-text az-ds-card-title"
                  },
                  [
                    _vm._v(
                      " Carteira " +
                        _vm._s(
                          _vm.statisticsAssets.Todos && _vm.dataFim
                            ? _vm.statisticsAssets.Todos.data_fim
                            : "atual"
                        ) +
                        " " +
                        _vm._s(
                          _vm.clienteAtual.name
                            ? " - " +
                                (_vm.clienteAtual.name.split(" ")[0] || "")
                            : ""
                        ) +
                        " "
                    )
                  ]
                ),
                !_vm.$currentUser().IS_CLIENTE
                  ? _c(
                      "v-btn",
                      {
                        attrs: { icon: "", "x-small": "", dense: "" },
                        on: { click: _vm.modalEntendaCarteira }
                      },
                      [
                        _c("icon-svg", {
                          attrs: {
                            name: "mdi-information",
                            size: "16",
                            color: "#8E8E8E"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "d-flex align-center",
                staticStyle: { gap: "12px" }
              },
              [
                _c("v-checkbox", {
                  staticClass: "m-0 p-0",
                  attrs: {
                    label: "Apresentar ativos resgatados",
                    "hide-details": ""
                  },
                  model: {
                    value: _vm.filterOldAssets,
                    callback: function($$v) {
                      _vm.filterOldAssets = $$v
                    },
                    expression: "filterOldAssets"
                  }
                }),
                _c("input-by-type", {
                  attrs: { type: "search", placeholder: "Pesquisar ativo" },
                  model: {
                    value: _vm.searchInput,
                    callback: function($$v) {
                      _vm.searchInput = $$v
                    },
                    expression: "searchInput"
                  }
                })
              ],
              1
            )
          ]),
          _vm.loadingInternal || _vm.carregandoSugestoes
            ? _c(
                "div",
                { staticClass: "carteira-ativos__loading" },
                [
                  _c("v-progress-linear", {
                    attrs: { indeterminate: "", color: "primary", rounded: "" }
                  })
                ],
                1
              )
            : _vm._e(),
          _c("AssetsByGroupTable", {
            attrs: {
              "sugestoes-pendentes-por-ativo": _vm.sugestoesPendentesPorAtivo,
              "sugestoes-por-movimentacao": _vm.sugestoesPorMovimentacao,
              "movimentacoes-das-sugestoes": _vm.movimentacoesDasSugestoes,
              statisticsAssets: _vm.statisticsAssets,
              clienteAtual: _vm.clienteAtual,
              ativosSelecionados: _vm.ativosSelecionadosInside,
              ativosSelecionadosPorClasse: _vm.selectedAssetsByClass,
              carteiraTabela: _vm.tableWallet,
              estatisticasClasse: _vm.estatisticasClasse,
              composicaoFundos: _vm.composicaoFundos,
              movimentacoes: _vm.movimentacoes,
              alertMarcacaoMercadoRF: _vm.alertMarcacaoMercadoRF,
              mapperBenchmarks: _vm.mapperBenchmarks,
              filtroCorretora: _vm.filtroCorretora,
              modoFiltroCorretora: _vm.modoFiltroCorretora,
              loadingRentAsset: _vm.loadingRentAsset,
              benchmarks: _vm.benchmarks,
              ativos: _vm.assets,
              "search-query": _vm.searchQuery,
              currency: _vm.currency,
              investmentType: _vm.investmentType,
              readonly: _vm.readonly,
              "allowed-actions": _vm.allowedActions,
              "columns-config": _vm.columnsConfig,
              "visible-columns": _vm.effectiveVisibleColumns,
              carteirasRecomendadas: _vm.carteirasRecomendadas,
              mostrarClasseAnbima: _vm.mostrarClasseAnbima,
              plTotal: _vm.plTotal
            },
            on: {
              updateAtivosSelecionados: function(val) {
                return (_vm.ativosSelecionadosInside = val)
              },
              selecionarAtivosClasse: _vm.selecionarAtivosClasse,
              openSaveBenchmark: _vm.openSaveBenchmark,
              openNewAtivo: _vm.openNewAtivo,
              aporteResgate: _vm.aporteResgate,
              openVincular: _vm.openVincular,
              openModalDelete: _vm.openModalDelete
            },
            scopedSlots: _vm._u([
              {
                key: "actions-header",
                fn: function() {
                  return [
                    !_vm.$currentUser().IS_CLIENTE
                      ? _c("SelectGroupedSearch", {
                          staticClass: "carteira-ativos__columns-selector",
                          attrs: {
                            items: _vm.columnGroups,
                            value: _vm.selectedColumnIds,
                            "disabled-items": _vm.lockedSelectorIds,
                            "menu-min-width": 325,
                            "selectable-leaf-groups": "",
                            "preserve-order": "",
                            "hide-clear-selection": ""
                          },
                          on: { input: _vm.handleColumnsInput },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "span",
                                      _vm._g(
                                        _vm._b({}, "span", attrs, false),
                                        on
                                      ),
                                      [
                                        _c("ActionButton", {
                                          attrs: {
                                            iconOnly: "",
                                            iconName: "colunas-3",
                                            label: "Colunas visíveis"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                }
                              },
                              {
                                key: "footer",
                                fn: function() {
                                  return [
                                    _c(
                                      "BaseButton",
                                      {
                                        attrs: {
                                          underlined: "",
                                          sm: "",
                                          fitContent: ""
                                        },
                                        on: { click: _vm.resetColumnsToDefault }
                                      },
                                      [_vm._v(" Restaurar padrão ")]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            3814005180
                          )
                        })
                      : _vm._e()
                  ]
                },
                proxy: true
              }
            ])
          }),
          _c("div", { staticClass: "carteira-ativos__legenda" }, [
            _c(
              "div",
              {
                staticClass:
                  "carteira-ativos__legenda-title text-subtitle-small mb-2"
              },
              [_vm._v(" LEGENDA ")]
            ),
            _c(
              "div",
              {
                staticClass:
                  "carteira-ativos__legenda-items text-xs text-color-900"
              },
              [
                _vm.mostraLegendaSugestoes
                  ? _c(
                      "div",
                      {
                        staticClass: "d-inline-flex align-center az-gap-xsmall",
                        attrs: { "data-test": "legenda-sugestoes-ia" }
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "carteira-ativos__legenda-sugestoes" },
                          [
                            _c("icon-svg", {
                              attrs: {
                                name: "warning",
                                size: "10",
                                color: "var(--warning-new)"
                              }
                            })
                          ],
                          1
                        ),
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.textsAssetTags.legendaSugestoes) +
                              " "
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "d-inline-flex align-center az-gap-xsmall" },
                  [
                    _c(
                      "v-chip",
                      {
                        staticStyle: { height: "16px" },
                        attrs: { color: "info", "x-small": "" }
                      },
                      [_vm._v(" MM ")]
                    ),
                    _c("span", [_vm._v(" Marcação a mercado ")])
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "d-inline-flex align-center az-gap-xsmall" },
                  [
                    _c(
                      "v-chip",
                      {
                        staticStyle: { height: "16px" },
                        attrs: { color: "primary", "x-small": "" }
                      },
                      [
                        _c("v-icon", { attrs: { small: "" } }, [
                          _vm._v(" mdi-currency-usd-off ")
                        ])
                      ],
                      1
                    ),
                    _c("span", [_vm._v(" Isento de IR ")])
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "d-inline-flex align-center az-gap-xsmall" },
                  [
                    _c(
                      "v-chip",
                      {
                        staticStyle: {
                          height: "16px",
                          "text-decoration": "line-through"
                        },
                        attrs: { color: "success", "x-small": "" }
                      },
                      [_vm._v(" fee ")]
                    ),
                    _c("span", [_vm._v(" Isento no cálculo de fee ")])
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "d-inline-flex align-center az-gap-xsmall" },
                  [
                    _c(
                      "v-chip",
                      {
                        staticStyle: {
                          height: "16px",
                          "text-decoration": "line-through"
                        },
                        attrs: { color: "warning", "x-small": "" }
                      },
                      [_vm._v(" % ")]
                    ),
                    _c("span", [_vm._v(" Desconsiderado na rentabilidade ")])
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "d-inline-flex align-center az-gap-xsmall" },
                  [
                    _c("icon-svg", {
                      attrs: {
                        name: "mdi-chart-pie",
                        size: "16",
                        color: "primary"
                      }
                    }),
                    _c("span", [_vm._v(" Ativo com composição ")])
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "d-inline-flex align-center az-gap-xsmall" },
                  [
                    _c("icon-svg", {
                      attrs: { name: "mdi-domain", size: "16", color: "info" }
                    }),
                    _c("span", [_vm._v(" Ativo iliquido ")])
                  ],
                  1
                ),
                !_vm.$currentUser().IS_CLIENTE
                  ? _c(
                      "div",
                      {
                        staticClass: "d-inline-flex align-center az-gap-xsmall"
                      },
                      [
                        _c("icon-svg", {
                          attrs: {
                            name: "warning-status",
                            color: "#E0AF00",
                            size: "16"
                          }
                        }),
                        _c("span", [_vm._v(" Fora da margem suitability ")])
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }